import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import StoreButtons from "@/components/StoreButtons";

/** "Get the LuxeRay app" chooser opened by the navbar / hero download buttons. */
export default function GetAppDialog({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md bg-[#02050F] border border-[#00F0FF]/15 p-6" data-testid="get-app-dialog">
        <div className="flex items-center gap-4 mb-5">
          <img src="/luxeray-app-icon.png" alt="LuxeRay app icon" className="w-16 h-16 rounded-2xl shadow-lg shadow-black/40" />
          <div>
            <DialogTitle className="font-disp text-2xl tracking-wide text-white leading-none">LuxeRay Smart Homes</DialogTitle>
            <p className="font-mono-lbl text-[11px] text-[#00F0FF] uppercase tracking-widest mt-1">Native AIoT Control Hub · iOS & Android</p>
          </div>
        </div>
        <DialogDescription className="text-white/70 text-sm mb-5">Command every zone, scene and sensor in milliseconds. Choose your store:</DialogDescription>
        <StoreButtons size="md" testid="get-app" />
      </DialogContent>
    </Dialog>
  );
}
